import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { MessageCircle, Mail, Phone } from 'lucide-react';
import Button from '../../../components/common/Button/MyButton';
import '../../../assets/styles/customer/layout/ContactHero.css';

const ContactHero = () => {
  const contactMethods = [
    {
      id: 1,
      icon: <MessageCircle size={32} strokeWidth={2} />,
      title: 'WhatsApp',
      subtitle: 'Quick responses, usually within minutes',
      contactInfo: '+92 300 1234567',
      buttonText: 'Chat Now',
      color: '#3e96e7',
      action: 'whatsapp'
    },
    {
      id: 2,
      icon: <Mail size={32} strokeWidth={2} />,
      title: 'Email',
      subtitle: 'For detailed inquiries and support',
      contactInfo: 'support@milkflow.pk',
      buttonText: 'Send Email',
      color: '#3e96e7',
      action: 'email'
    },
    {
      id: 3,
      icon: <Phone size={32} strokeWidth={2} />,
      title: 'Phone',
      subtitle: 'Monday to Saturday, 9AM - 6PM',
      contactInfo: '+92 42 1234567',
      buttonText: 'Call Us',
      color: '#3e96e7',
      action: 'phone'
    }
  ];

  return (
    <section className="contact-hero-section">
      
      {/* Floating Contact Icons */}
      <div className="contact-floating-icons">
        <div className="float-contact-icon icon-1">📱</div>
        <div className="float-contact-icon icon-2">✉️</div>
        <div className="float-contact-icon icon-3">💬</div>
        <div className="float-contact-icon icon-4">📞</div>
        <div className="float-contact-icon icon-5">📧</div>
        <div className="float-contact-icon icon-6">📲</div>
      </div>

      {/* Decorative Circles */}
      <div className="contact-circles">
        <div className="contact-circle circle-1"></div>
        <div className="contact-circle circle-2"></div>
      </div>

      {/* Wave Pattern */}
      <div className="contact-wave-pattern">
        <svg className="contact-wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(62, 150, 231, 0.05)" 
            d="M0,96L48,112C96,128,192,160,288,154.7C384,149,480,107,576,101.3C672,96,768,128,864,138.7C960,149,1056,139,1152,128C1248,117,1344,107,1392,101.3L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
      </div>

      <Container>
        
        {/* Hero Header */}
        <div className="contact-hero-header">
          <div className="contact-badge">Get in Touch</div>
          <h1 className="contact-hero-title">
            We're Here to <span className="contact-hero-highlight">Help You</span>
          </h1>
          <p className="contact-hero-subtitle">
            Have questions? Our team is ready to assist you with anything you need.
          </p>
        </div>

        {/* Contact Cards */}
        <Row className="g-4 contact-cards-row">
          {contactMethods.map((method, index) => (
            <Col lg={4} md={4} sm={12} key={method.id}>
              <div 
                className="contact-method-card"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                
                {/* Icon */}
                <div 
                  className="contact-icon-wrapper"
                  style={{ backgroundColor: `${method.color}15` }}
                >
                  <div 
                    className="contact-method-icon"
                    style={{ color: method.color }}
                  >
                    {method.icon}
                  </div>
                </div>

                {/* Title */}
                <h3 className="contact-method-title">{method.title}</h3>
                
                {/* Subtitle */}
                <p className="contact-method-subtitle">{method.subtitle}</p>

                {/* Contact Info */}
                <p 
                  className="contact-info-text"
                  style={{ color: method.color }}
                >
                  {method.contactInfo}
                </p>

                {/* Action Button */}
                <Button 
                  variant="outline-primary" 
                  className="contact-action-btn"
                >
                  {method.buttonText}
                </Button>

              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default ContactHero;